/**
* This file was auto-generated by the FrontendConstantsGenerator.
* Do not make direct changes to the file.
*/

export const ATTRIBUTE_TYPES = {
  BOOLEAN: 'boolean',
  DATE: 'date',
  DECIMAL: 'decimal',
  INTEGER: 'integer',
  SINGLE_SELECT: 'single_select',
  SINGLE_SELECT_WITH_OTHER: 'single_select_with_other',
  STRING: 'string',
  MULTI_SELECT: 'multi_select',
};
// Population attribute types we can create
// Note: This is in an intentional sort order, do not alphabetize
export const ATTRIBUTE_NAMES = {
  [ATTRIBUTE_TYPES.STRING]: 'Text',
  [ATTRIBUTE_TYPES.DECIMAL]: 'Number',
  [ATTRIBUTE_TYPES.DATE]: 'Date',
  [ATTRIBUTE_TYPES.BOOLEAN]: 'True/False',
};
